<template>
    <div class="container-fluid landings-page">


        <div class="row mt-5 h-100 justify-content-center ">
            <div class="col-3 p-3 m-3   bg-white shadow rounded border-magenta">
                <div class="">
                    <h2>{{ $t('contact.contactUs') }}</h2>
                </div>
                <div class="">
                    {{ $t('contact.suggestionsAndIssues') }}
                </div>
                <ul class="list-unstyled mt-2 color-blue">
                    <li><a href="mailto:info@ray-iq.com" class="color-blue small-button "><b-icon-envelope-fill class="mr-2" />   info@ray-iq.com </a></li>
                    <li><a href="tel:+31334943964" class="color-blue small-button mt-2 "><b-icon-telephone-fill class="mr-2" /> +31 33 494 3964 </a></li>
                </ul>

            </div>
            <div class="col-3 p-3 m-3 bg-white shadow rounded border-magenta">
                <div class="">
                    <h2> {{ $t('contact.salesAndLogistics') }}</h2>
                </div>
                <div class="">
                    <span v-html="$t('contact.salesRelatedQuestions')"></span>
                    <ul class="list-unstyled mt-2 color-blue">
                        <li><a href="mailto:sales@cablon.nl" class="color-blue small-button "><b-icon-envelope-fill class="mr-2" /> sales@cablon.nl</a></li>
                        <li ><a href="tel:+31334943964" class="color-blue small-button mt-2 "><b-icon-telephone-fill class="mr-2" /> +31 33 494 3964</a></li>

                        <!--<li class="mt-3">
                            Klepelhoek 11
                        </li>
                        <li>
                            3833 GZ
                        </li>
                        <li>
                            Leusden
                        </li>
                        <li>The Netherlands</li>-->
                    </ul>

                </div>
            </div>
        </div>

    </div>



</template>

<script>
    export default {
        name: 'Contact',
        components: {

        }
    }
</script>